module.exports = __webpack_public_path__ + "img/News.7f1ce8bb.webp";